import { useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { VerifyPanel } from "@/components/auth/VerifyPanel";
import { Logo } from "@/components/Logo";

export default function Verify() {
  const { user } = useAuth();
  const { state } = useLocation();
  const navigate = useNavigate();
  if (!user) return null;
  const done = user.email_verified && user.mobile_verified;
  return (
    <div className="min-h-screen bg-[#07080E] text-slate-100 grain">
      <nav className="h-16 px-6 sm:px-10 flex items-center border-b border-white/10"><Logo size={34} /></nav>
      <div data-testid="verify-page" className="max-w-3xl mx-auto px-6 py-12">
        <div className="text-xs font-mono uppercase tracking-widest text-cyan-400 mb-2 flex items-center gap-2"><ShieldCheck size={13} /> Account verification</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold">Welcome, {user.first_name || user.name}</h1>
        <p className="text-slate-400 mt-2 text-sm">Verify your email and WhatsApp number to unlock payments, referral bonuses and render alerts. You can also do this later from My Account.</p>
        <div className="mt-8"><VerifyPanel user={user} initial={state?.verification} /></div>
        <button data-testid="verify-continue" onClick={() => navigate(state?.next || "/studio")} className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-gradient-to-r from-purple-600 to-cyan-600 text-white">
          {done ? "Enter the Studio" : "Skip for now — enter the Studio"} <ArrowRight size={15} />
        </button>
      </div>
    </div>
  );
}
